export default {
    loaded: ({user}) => user.loaded,
    user: ({user}) => user.user,
    isAuth: ({user}) => user.user !== null,
    game: ({user}) => user.game,
    online: ({user}) => user.online,
    online_timestamp: ({user}) => user.online_timestamp,
    bonus_state: ({user}) => user.bonus_state,
    games_tab: ({user}) => user.games_tab,
    favorites: ({user}) => user.favorites,
    currency: ({user}) => user.user.currency,
    bets_amount: ({user}) => user.bets_amount,
    buttons: {
        game: ({user}) => user.buttons.game,
        changeAvatar: ({user}) => user.buttons.changeAvatar,
        changePassword: ({user}) => user.buttons.changePassword,
        favorite: ({user}) => user.buttons.favorite,
        take_bonus: ({user}) => user.buttons.take_bonus,
        spin: ({user}) => user.buttons.spin
    }
}